<script setup lang="ts">
import { type AdvancedEventFilters } from '@/types/filters/EventFilters'
import { CheckboxField, StackLayout } from '@rfc/rfc-components-library'

type Props = {
    filters?: Partial<AdvancedEventFilters>
    hasErrors?: Partial<{
        period: boolean
        field: boolean
    }>
}
defineProps<Props>()
type Emits = {
    (e: 'change', filters: Partial<AdvancedEventFilters>): void
}
defineEmits<Emits>()
</script>

<template>
    <StackLayout direction="column" :gap="8">
        <CheckboxField
            :label="$t('event.filters.showFinished')"
            :modelValue="!!filters?.finished"
            @change="$emit('change', { finished: $event ? 1 : undefined })" />
        <CheckboxField
            :label="$t('event.filters.showOngoing')"
            :modelValue="!!filters?.ongoing"
            @change="$emit('change', { ongoing: $event ? 1 : undefined })" />
        <CheckboxField
            :label="$t('event.filters.showUpcoming')"
            :modelValue="!!filters?.upcoming"
            @change="$emit('change', { upcoming: $event ? 1 : undefined })" />
    </StackLayout>
</template>
